import { useReturnToPatientList } from './useReturnToPatientList';
import ReturnToListButton from './ReturnToListButton';

/**
 * The way back to the worklist while no patient is loaded — a failed open
 * leaves the viewer empty, and that is exactly when the user must be able to
 * leave. No confirmation: with nothing loaded there is nothing to discard.
 *
 * With a patient loaded the same control is rendered by {@link PatientMenu},
 * which owns the confirmation that closing one requires.
 */
export default function BackToPatientListButton() {
    const { available, closesPatient, returnToList } = useReturnToPatientList();

    if (!available || closesPatient) {
        return null;
    }

    return <ReturnToListButton onClick={returnToList} />;
}
